import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface FAQProps {
  language: 'en' | 'es';
}
export function FAQ({
  language
}: FAQProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const t = {
    en: {
      heading: 'Frequently Asked Questions',
      faqs: [{
        q: 'What areas do you serve?',
        a: 'We serve Odessa, Midland, Andrews, Pecos, Fort Stockton, Monahans, Kermit, Crane, and surrounding West Texas areas. Call us to confirm availability in your specific location.'
      }, {
        q: 'What rentals do you offer?',
        a: 'Portable restrooms, trash trailers, combo trailers, dump trailers, and handwashing stations. We have options for job sites, events, ranches, and more.'
      }, {
        q: 'How much does a rental cost?',
        a: 'Pricing depends on rental type, duration, and delivery location. Call or text us at 432-528-7892 or 432-803-4737 for a fast, no-obligation quote — most quotes delivered same day.'
      }, {
        q: 'How quickly can you deliver?',
        a: 'We offer same-day and next-day delivery for most areas depending on availability. Contact us early to secure your preferred date and time.'
      }, {
        q: 'Are your units clean?',
        a: 'Every unit is thoroughly cleaned and sanitized before each delivery. We maintain our fleet to the highest standard.'
      }, {
        q: 'Do you deliver to oilfield locations?',
        a: 'Absolutely. We regularly serve oilfield crews across the Permian Basin. We know how critical sanitation is on a live work site.'
      }]
    },
    es: {
      heading: 'Preguntas Frecuentes',
      faqs: [{
        q: '¿Qué áreas sirven?',
        a: 'Servimos Odessa, Midland, Andrews, Pecos, Fort Stockton, Monahans, Kermit, Crane y áreas circundantes de West Texas. Llámanos para confirmar disponibilidad en tu ubicación.'
      }, {
        q: '¿Qué rentas ofrecen?',
        a: 'Baños portátiles, remolques de basura, remolques combo, dump trailers y estaciones de lavado de manos. Tenemos opciones para obras, eventos, ranchos y más.'
      }, {
        q: '¿Cuánto cuesta una renta?',
        a: 'El precio depende del tipo de renta, duración y ubicación de entrega. Llama o envía un texto al 432-528-7892 o 432-803-4737 para una cotización rápida y sin compromiso — la mayoría se entregan el mismo día.'
      }, {
        q: '¿Qué tan rápido pueden entregar?',
        a: 'Ofrecemos entrega el mismo día y al día siguiente para la mayoría de las áreas según disponibilidad. Contáctanos temprano para asegurar tu fecha y hora preferida.'
      }, {
        q: '¿Están limpias sus unidades?',
        a: 'Cada unidad es limpiada y desinfectada a fondo antes de cada entrega. Mantenemos nuestra flota al más alto estándar.'
      }, {
        q: '¿Entregan a ubicaciones petroleras?',
        a: 'Absolutamente. Servimos regularmente a equipos petroleros en toda la Cuenca Permian. Sabemos lo crítico que es la sanidad en un sitio de trabajo activo.'
      }]
    }
  };
  const text = t[language];
  return <section id="faq" className="py-12 md:py-20 bg-darkBg w-full overflow-hidden" data-id="element-42">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-43">
        <div className="text-center mb-8 md:mb-12" data-id="element-44">
          <h2 className="font-oswald text-3xl sm:text-4xl md:text-5xl font-bold text-warmWhite uppercase" data-id="element-45">
            {text.heading}
          </h2>
        </div>

        <div className="space-y-3" data-id="element-46">
          {text.faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05
        }} className="bg-carbon border border-steel rounded-lg overflow-hidden" data-id="element-47">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex justify-between items-center text-left focus:outline-none hover:bg-steel/30 transition-colors" data-id="element-48">
                <span className="font-inter font-semibold text-warmWhite text-base md:text-lg pr-8" data-id="element-49">
                  {faq.q}
                </span>
                <ChevronDown className={`flex-shrink-0 text-gold transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-50" />
              </button>

              <AnimatePresence data-id="element-51">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-52">
                    <div className="px-6 pb-5 pt-1 text-gray-400 font-inter leading-relaxed text-sm md:text-base" data-id="element-53">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}